import { useEffect, useState } from 'react';

export const useScrollIndicator = (thresholdElement) => {
  const [shouldShowIndicator, setShouldShowIndicator] = useState(false);

  useEffect(() => {
    if (!(thresholdElement instanceof Element)) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        setShouldShowIndicator(!entry.isIntersecting);
      },
      { threshold: 0.5 },
    );

    observer.observe(thresholdElement);

    return () => observer.disconnect();
  }, [thresholdElement]);

  return { shouldShowIndicator };
};
